import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const Total = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <div className="info-container-dashboards-green">
            <div className="info-box-dashboards-green">
                <span className="info-value-green-dashboards">
                    {number.formatToBRNumber(
                        (
                            chartData?.counterServices.reduce(
                                (acc, curr) =>
                                    acc + Number(curr.average_permanences),
                                0
                            ) / (chartData?.counterServices.length || 1)
                        ).toFixed(2)
                    )}
                </span>
                <span className="info-label">Média de Permanência</span>
            </div>
        </div>
    );
};
